import { type FilterType, FilterTypes } from '@axinom/mosaic-ui';
import type { PermissionFilters } from './models';

export const permissionNameFilter: FilterType<PermissionFilters> = {
  label: 'Permissions',
  property: 'permission',
  type: FilterTypes.FreeText,
};

export const statusFilter: FilterType<PermissionFilters> = {
  label: 'Assigned',
  property: 'isAssigned',
  type: FilterTypes.Options,
  options: [
    {
      label: 'ON',
      value: 'ON',
    },
    {
      label: 'OFF',
      value: 'OFF',
    },
  ],
};

export const isManagedFilter: FilterType<PermissionFilters> = {
  label: 'Managed Service',
  property: 'isManaged',
  type: FilterTypes.Options,
  options: [
    {
      label: 'true',
      value: 'TRUE',
    },
    {
      label: 'false',
      value: 'FALSE',
    },
  ],
};

export const isInheritedFilter: FilterType<PermissionFilters> = {
  label: 'Inherited',
  property: 'isInherited',
  type: FilterTypes.Options,
  options: [
    {
      label: 'TRUE',
      value: 'TRUE',
    },
    {
      label: 'FALSE',
      value: 'FALSE',
    },
  ],
};
